// extracted by mini-css-extract-plugin
module.exports = {"body":"Payment_body__1dLB5","container":"Payment_container__2NFpP","row":"Payment_row__156NH","payBtnContainer":"Payment_payBtnContainer__12O0y","payBtn":"Payment_payBtn__1JIC1"};